import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import packageJson from '../../../package.json';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private readonly version: string;

  constructor() {
    this.version = packageJson.version || 'unknown';
  }

  getVersion(): Observable<string> {
    return of(this.version);
  }
}

